<script>
    import HeaderInfo from "./MenuComponents/HeaderInfo.svelte";
    import DateAndTime from "./Form-Components/DateAndTime.svelte";
    import Services from "./Form-Components/Services.svelte";
    import {writable} from "svelte/store";

    const selectedServices = writable(new Set());
    let stage = writable("services");
    function handleBack() {
        stage.set("services");
    }
</script>

<style>
    .form-main-div{
        max-width: 50%;
        width: 50%;
    }
    .form-padding{
        padding-bottom: 250px;
    }
    @media (max-width: 768px) {
        .form-main-div{
            width: 100%;
            max-width: unset;
        }
        .form-padding{
            padding-bottom: 50%;
            margin: 0 5%;
        }
    }

</style>

<div class="form-main-div">
    <HeaderInfo />
    <div class="form-padding">
        {#if $stage === 'services'}
            <Services bind:stage={$stage} selectedServices={selectedServices}/>
        {:else if $stage === 'dateAndTime'}
            <DateAndTime on:back={handleBack} selectedServices={selectedServices}/>
        {/if}
    </div>
</div>
